module.exports = __webpack_public_path__ + "static/media/8.528e570c.jpg";